import './index.css'
import App from './App'
import { createRoot } from 'react-dom/client'
import { createStores } from '@migrate/stores'
import { initAxios } from '@migrate/utils/axiosInterceptor'
import { LicenseManager } from 'ag-grid-enterprise'
import { deleteLegacyIdleLogoutKeys } from '@auth/data/idleLogout'

// An earlier release saved a timed-out tab's address in plain text. Every tab deletes it on start.
deleteLegacyIdleLogoutKeys()

// THIS HAS TO STAY HERE! Because we are mixing old dumb globals with new modern code-splitting, moving this will break the world.
createStores()
// These can probably move since they hit the vendor bundle, but nice to keep all global stuff together.
initAxios()
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-067603}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{State_Street_Bank_and_Trust_Company_(Accounts_Payable)}_is_granted_a_{Multiple_Applications}_Developer_License_for_{20}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{5}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_February_2026}____[v3]_[01]_MTc3MDI0OTYwMDAwMA==829e4dc09b00720a269c35f5843a225e',
)

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<App />)
